import { WatchmanFetch } from '../../../shared/utils/watchmanFetch';
import type { Tenant, CreateTenantPayload, TenantApiKeyResult } from '../types';

export const tenantsApi = {
  // This admin surface manages brand-website tenants only — commerce tenants
  // stay on /merchants (which filters type=ECOMMERCE server-side).
  list: (): Promise<Tenant[]> => WatchmanFetch.get('/tenants?type=BRAND_WEBSITE'),
  get: (id: string): Promise<Tenant> => WatchmanFetch.get(`/tenants/${id}`),
  create: (data: CreateTenantPayload): Promise<Tenant> => WatchmanFetch.post('/tenants', data),
  activate: (id: string): Promise<Tenant> => WatchmanFetch.patch(`/tenants/${id}/activate`, { id }),
  deactivate: (id: string): Promise<Tenant> => WatchmanFetch.patch(`/tenants/${id}/deactivate`, { id }),
  // Rotates/revokes any existing active key; the raw key is shown exactly once.
  generateApiKey: (id: string): Promise<TenantApiKeyResult> => WatchmanFetch.post(`/tenants/${id}/api-key`),
};
